import React, { useContext } from "react";

import type {
    GridPromoPlacements,
    ServerCmsTypesProductSummary as ProductSummary,
    SharedFavoritesContentBlock,
} from "@reactivated";

import { ReactivatedContext } from "../../context";
import { Themed } from "../../styles/themes";
import { RichTextStreamBlock } from "../RichTextStreamBlock";
import { FavoritesContent } from "./";

import styles from "./index.module.scss";

interface SharedFavoritesContentProps {
    value: SharedFavoritesContentBlock;
    products: ProductSummary[];
    gridPromos?: GridPromoPlacements;
}

export const SharedFavoritesContent = ({
    value,
    products,
    gridPromos,
}: SharedFavoritesContentProps) => {
    const context = useContext(ReactivatedContext);

    if (products.length === 0) {
        return (
            <Themed
                theme="offWhite"
                className={value.shared_empty_state_content ? styles.empty : ""}
            >
                <RichTextStreamBlock
                    value={value.shared_empty_state_content ?? null}
                />
            </Themed>
        );
    }

    return (
        <FavoritesContent
            products={products}
            isLoading={false}
            hasError={false}
            skus={products.map((product) => product.sku)}
            shareUrl={context.request.url}
            errorMessage={null}
            footerContent={value.footer_content ?? null}
            showFavoriteButton={false}
            gridPromos={gridPromos}
        />
    );
};
